module.exports={
	"Name": "Pict Docuserve",
	"Hash": "Docuserve",

	"MainViewportViewIdentifier": "Docuserve-Layout",

	"AutoSolveAfterInitialize": true,
	"AutoRenderMainViewportViewAfterInitialize": false,
	"AutoRenderViewsAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "Docuserve-Pict-Application"
		}
}
